import { v4 as uuidv4 } from 'uuid';

export function groupBy<T, K extends keyof any>(
  list: T[],
  getKey: (item: T) => K,
) {
  return list.reduce((previous, currentItem) => {
    const group = getKey(currentItem);
    // eslint-disable-next-line no-param-reassign
    if (!previous[group]) previous[group] = [];
    previous[group].push(currentItem);
    return previous;
  }, {} as Record<K, T[]>);
}

export function addUniqueKey<T extends Record<string, unknown>>(array: T[]) {
  return array.map((item) => ({ __id: uuidv4(), ...item }));
}

/**
 * convert a flat list of nodes into tree array
 * @param array list of nodes as flat array
 * @param parentChildData data to locate node parents
 */
export function listToTree<T extends Record<string, unknown>>(
  array: T[],
  parentChildData: (node: T, list: T[]) => T | undefined,
): (T & { children?: T[] })[] {
  const root: (T & { children?: T[] })[] = [];
  array.forEach((el) => {
    // Use our mapping to locate the parent element in our data array
    const parent = parentChildData(el, array);

    if (!parent) {
      root.push(el);
      return;
    }
    // Add our current el to its parent's `children` array
    (parent as any).children = [...((parent as any).children || []), el];
  });

  return root;
}

export function normalizeArray<T>(array: T[]): T[] {
  return array.filter(Boolean);
}
